import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import Grid from '@mui/material/Grid';
import { useSnackbar } from 'notistack';
import React from 'react';

import ServiceCard from './ServiceCard';

type ServicesListProps = {
  hasActiveDriverMembership: boolean;
  onSubmitTrafficIncident?: () => void;
};

const ServicesList: React.FC<ServicesListProps> = ({
  hasActiveDriverMembership,
  onSubmitTrafficIncident,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const servicesData = [
    {
      bgColor: '#FDF2F4',
      canShow: () => true,
      description:
        '24/7 emergency dispatch for breakdowns, tows, tires, and lockouts.',
      icon: LocalPhoneOutlinedIcon,
      iconColor: '#9B1C31',
      id: 1,
      linkHref: 'tel:18005550142',
      linkText: 'Call now',
      phoneNumber: '1-800-555-0142',
      title: 'Call Roadside Assistance',
    },
    {
      bgColor: '#FEFCE8',
      canShow: () => true,
      description:
        "Upload an incident and we'll track it through to resolution.",
      icon: DescriptionOutlinedIcon,
      iconColor: '#A16207',
      id: 2,
      linkText: 'Submit incident',
      title: 'Submit a Traffic Incident',
    },
    {
      bgColor: '#F0FDF4',
      canShow: () => hasActiveDriverMembership,
      description: 'Member discounts on hotels, tires, fuel, parts, and more.',
      icon: LocalOfferOutlinedIcon,
      iconColor: '#166534',
      id: 3,
      linkText: 'View Vendors',
      title: 'Access Market Place',
    },
  ];

  return (
    <Grid container spacing={3} sx={{ marginTop: '2px' }}>
      {servicesData
        .filter((service) => service.canShow())
        .map((service) => (
          <Grid item xs={12} md={6} lg={4} key={service.id}>
            <ServiceCard
              bgColor={service.bgColor}
              description={service.description}
              icon={service.icon}
              iconColor={service.iconColor}
              linkHref={service.linkHref}
              linkText={service.linkText}
              onLinkClick={() => {
                if (service.id === 2) {
                  onSubmitTrafficIncident?.();
                  return;
                }

                if (service.id === 3) {
                  enqueueSnackbar(`Selected: ${service.title}`, {
                    variant: 'info',
                  });
                  return;
                }
              }}
              phoneNumber={service.phoneNumber}
              title={service.title}
            />
          </Grid>
        ))}
    </Grid>
  );
};

export default ServicesList;
